import { render, staticRenderFns } from "./StatuswiseTeam.vue?vue&type=template&id=39e9e681&scoped=true"
import script from "./StatuswiseTeam.vue?vue&type=script&lang=js"
export * from "./StatuswiseTeam.vue?vue&type=script&lang=js"
import style0 from "./StatuswiseTeam.vue?vue&type=style&index=0&id=39e9e681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e9e681",
  null
  
)

export default component.exports